// extracted by mini-css-extract-plugin
export default {"refundedRedeemedVouchers":"sales-summary--refundedRedeemedVouchers--94de94","redeemedVouchers":"sales-summary--redeemedVouchers--4e4001"};